
<div class="nav-user-tab-item">
    <v-autocomplete
        dense
        chips
        label="Meine Kunden"
        multiple
        deletable-chips
        hide-no-data
        return-object
        auto-select-first
        :hide-selected = "true"
        v-model       = "selected"
        :items        = "items"
        :menu-props   = "menuProps"
        item-value    = "id"
        item-text     = "name"
        autocomplete  = "off"
        autocorrect   = "off"
        autocapitalize= "off"
        spellcheck    = "false"
        @change       = "onChange"
        append-icon=""
        ref="select"
    >
        <template v-slot:item="data">
            <v-list-item-content>
                <v-list-item-title class="component-title" v-html="data.item.name"></v-list-item-title>
            </v-list-item-content>
        </template>
        <!--
        <template v-slot:selection="{ item }">
            <v-chip
                style        = "margin: 1px"
                close
                close-icon="mdi-close"
                class="w-50"
            >
                <div class="pl-1">
                    <div class="selected-items">
                        {{ item.name }}
                    </div>
                </div>
            </v-chip>
        </template>
        -->
    </v-autocomplete>
</div>
